import { Button, Table, Tooltip } from "antd";
import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import * as XLSX from "xlsx";
import commonfunction from "../utilities/commonFunction.js";
import axiosInstance from '../utilities/axiosInstance';
import { useSearch } from '../context/SearchContext.js';
import { PiDownloadSimple } from "react-icons/pi";
import "../styles/profileDetails.scss"

const AllProfileData = ({reload}) => {
  const [data, setData] = useState([]);
  const [xlsxData, setxlsxData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const { searchValue } = useSearch();

  const getAllProfiles = () => {
    axiosInstance
      .get(`/taggerandreviewerprofiles`)
      .then((response) => {
        const managerProfiles = response.data.length > 0 ? response.data : [];
        const managerProfile = managerProfiles.map((v, i, arr) => {
          //project_Name: projectData.filter(item => arr[i].project_id.split(',').every(value => item.project_id == value))
          return {
            createdDate: arr[i].createdDate,
            modifiedDate: arr[i].modifiedDate,
            profile_email: arr[i].profile_email,
            profile_fullname: arr[i].profile_fullname,
            profile_id: arr[i].profile_id,
            profile_name: arr[i].profile_name,
            profile_role: arr[i].profile_role,
            profile_username: arr[i].profile_username,
            role_name: arr[i].role_name,
            project_id: arr[i].project_id,
            project_name: arr[i].project_name,
            profile_login_session: arr[i].profile_login_session,
            profile_login_datetime:
              arr[i].profile_login_session > 0 &&
                commonfunction.getHours(arr[i].profile_login_datetime) > 0
                ? commonfunction.getHours(arr[i].profile_login_datetime) +
                " Hours"
                : 0 + " Hours",
          };
        });
        const tempData = managerProfiles.map((v, i, arr) => {
          return {
            FullName: arr[i].profile_fullname,
            UserName: arr[i].profile_username,
            Role: arr[i].role_name,
          };
        });
        setxlsxData(tempData);
        setData(managerProfile);
        setFinalData(managerProfile);
      })
      .catch((error) => console.error(error));
  };
  // Function to handle download button click
  const handleDownload = () => {
    const worksheet = XLSX.utils.json_to_sheet(xlsxData); // Convert data to worksheet
    const workbook = XLSX.utils.book_new(); // Create a new workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Profiles"); // Add worksheet to the workbook
    XLSX.writeFile(workbook, "profiles.xlsx"); // Write workbook to an Excel file and download it
  };

  const columns = [
    {
      title: (
        <Tooltip title="Full Name">
          <span>Name</span>
        </Tooltip>
      ),
      dataIndex: "profile_fullname",
      key: "fullname",
    },
    {
      title: (
        <Tooltip title="Username">
          <span>Username</span>
        </Tooltip>
      ),
      dataIndex: "profile_username",
      key: "username",
    },
    {
      title: (
        <Tooltip title="Assigned Projects">
          <span>Assigned Projects</span>
        </Tooltip>
      ),
      dataIndex: "project_name",
      key: "projectname",
    },
    {
      title: (
        <Tooltip title="Role">
          <span>Role</span>
        </Tooltip>
      ),
      dataIndex: "role_name",
      key: "role",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: (
        <Tooltip title="Login hours">
          <span>Login Hours</span>
        </Tooltip>
      ),
      dataIndex: "profile_login_datetime",
      key: "datetime",
    },
  ];
  useEffect(() => {
    if (searchValue !== "") {
      const newData = data.filter((item) => {
        return item.profile_email
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
      setFinalData(newData);
    } else {
      setFinalData(data);
    }
  }, [searchValue]);

  console.log("Reload", reload)
  useEffect(() => {
    getAllProfiles();
  }, [reload]);

  return (
    <>
      <div className="profileDetails">
        <div className="mb-[26px] flex justify-end -mt-[47px]">
          {/* Button to trigger download */}
          <button type="primary" onClick={handleDownload} className="w-[150px] h-[40px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] hover:from-[#00B4D2] hover:to-[#C300A0] flex gap-3 justify-center items-center">
            <PiDownloadSimple className="text-[24px]" /> Download
          </button>
        </div>
        <Table className="details-view-table"
          columns={columns}
          dataSource={finalData}
          rowClassName={() => "custom-row-gap"}
          pagination={{
            pageSize: 6,
            position: ["bottomCenter"],
            showSizeChanger: false,
            showQuickJumper: false,
          }}
        />
      </div>
    </>
  );
};
export default AllProfileData;
